import { dialog } from '#client/src/components/modal/modal.ts'
import { storage } from '#client/src/services/storage.ts'
import { addStorageCleanupObserver } from '#client/src/services/version.ts'
import { api } from '#client/src/services/api.ts'
import { useForm } from '#client/src/services/form.ts'
import { reactive } from 'vue'
import { transcode } from '../..'

import type { AppType, Information } from '=/types'
import { openInBackground } from '#client/src/services/window.ts'

const BMN_USER_INFORMATION = '__textures_ui__'

export const errorMessage = reactive({
  show: false,
  message: 'Om de texturen te downloaden moet je eerst je gegevens invullen.'
})

export const { component: InformationModal, open: openInformation, close: closeInformation } = dialog(() => import('./Modal.vue'))

export const storedUserValues = storage.get<Information>(BMN_USER_INFORMATION)

export const values = useForm<Information>({
  first_name: storedUserValues?.first_name || '',
  last_name: storedUserValues?.last_name || '',
  email: storedUserValues?.email || '',
  method: storedUserValues?.method || 'email',
  timestamp: storedUserValues?.timestamp
})

export async function submitInfomation(app: AppType) {
  storage.set(BMN_USER_INFORMATION, values.form.value)

  window.gtag('event', 'download_texturen', {
    event_category: 'texturegenerator',
    event_label: `De gegevens zijn ingevuld door: ${values.form.value.first_name} ${values.form.value.last_name} ${values.form.value.email}`,
    value: 1
  })

  try {
    const data = await api.post('/api/users', {
      body: values.form.value
    })

    if (!data) {
      errorMessage.show = true
      return
    }

    closeInformation()
    transcode(values.form.value, app)
  } catch (error) {
    console.error(error)
  } finally {
    openInBackground(app.thankYouUrl)
  }
}

addStorageCleanupObserver((key, area, reason) => {
  if (area !== 'local' || key !== BMN_USER_INFORMATION) return
  values.form.value = {
    first_name: '',
    last_name: '',
    email: '',
    method: 'email',
    timestamp: new Date().getTime()
  }
})
